import { render, staticRenderFns } from "./ocs-systems.vue?vue&type=template&id=510ae2ce&scoped=true"
import script from "./ocs-systems.vue?vue&type=script&lang=js"
export * from "./ocs-systems.vue?vue&type=script&lang=js"
import style0 from "./ocs-systems.vue?vue&type=style&index=0&id=510ae2ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510ae2ce",
  null
  
)

export default component.exports